import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
const LabelCard = ({ title, children }) => (
  <label className="d-block" htmlFor={"registrationData"}>
    <b>{title}</b>
    {children}
  </label>
);

const FormRegistration = (props) => {
  const {
    registrationData,
    showEmailModal,
    showSmsModal,
    userData,
    showCallModal,
  } = props;
  return (
    <div style={{ gridColumn: "1/span 2" }}>
      <h4 className="view-heading">Registration Form</h4>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2,minmax(0,1fr))",
          columnGap: "1.75rem",
        }}
      >
        <section>
          <LabelCard title={"Name: "}>
            <span>{`${registrationData?.firstName ?? ""} ${
              registrationData?.lastName ?? ""
            }`}</span>
          </LabelCard>
          <LabelCard title={"Address: "}>
            <span> {registrationData?.streetAddress}</span>
          </LabelCard>
          <LabelCard title={"Zipcode: "}>
            <span>{registrationData?.zipcode}</span>
          </LabelCard>

          <LabelCard title={"Landline Phone Number: "}>
            <span> {registrationData?.homePhoneNumber}</span>
          </LabelCard>
          <LabelCard title={"Alternate Phone Number: "}>
            <span> {registrationData?.alternatePhoneNumber}</span>
          </LabelCard>
        </section>
        <section>
          <div style={{ display: "flex", columnGap: "0.5rem" }}>
            <LabelCard title={"Email: "}>
              <a href={`mailto: ${registrationData?.email}`}>
                {registrationData?.email}
              </a>
            </LabelCard>
            <div style={{ display: "inline-block" }}>
              <span
                onClick={() => showEmailModal(userData)}
                className="connection"
              >
                <i
                  class="ti-email"
                  style={{
                    color: "#fff",
                    fontWeight: "500",
                    fontSize: "18px",
                  }}
                ></i>
              </span>
            </div>
          </div>
          <LabelCard title={"City: "}>
            <span>{registrationData?.city}</span>
          </LabelCard>
          <LabelCard title={"State: "}>
            <span> {registrationData?.stateName}</span>
          </LabelCard>
          <div style={{ display: "flex", columnGap: "0.5rem" }}>
            <LabelCard title={"Cell Number: "}>
              <span> {registrationData?.cellPhoneNumber}</span>
            </LabelCard>
            <div style={{ display: "inline-flex", alignItems:"start" , gap:"0.5rem"}}>
            <span
              onClick={() => showCallModal(userData)}
              className="connection"
            >
              <i
                class="fe fe-phone-call"
                style={{ color: "#fff", fontWeight: "500", fontSize: "18px" }}
              ></i>
            </span>
            <span onClick={() => showSmsModal(userData)} className="connection">
              <i
                class="fa fa fa-commenting-o"
                style={{ fontSize: "18px", cursor: "pointer", color: "#fff" }}
              ></i>
            </span>
            </div>
          </div>
          <LabelCard title={"DOB: "}>
            <span>{registrationData?.dateOfBirthToDisplay  ?? ""}</span>
          </LabelCard>
        </section>
      </div>
    </div>
  );
};

export default FormRegistration;
